module.exports = __webpack_public_path__ + "img/envelope-open.652cf78f.svg";